export const generateSnapshotOptionsFrom = (startMonth, startYear) => {
  const now = new Date();
  const options = [];
  let date = new Date(startYear, startMonth - 1, 1); // month is 0-indexed

  while (
    date.getFullYear() < now.getFullYear() ||
    (date.getFullYear() === now.getFullYear() && date.getMonth() <= now.getMonth())
  ) {
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    const label = `${month} ${year}`;
    const value = `${year}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;

    options.push({ value, label });
    date.setMonth(date.getMonth() + 1);
  }

  return options.reverse(); // newest first
};